// hooks/useToggleAutoBilling.ts
import { useQuery } from '@tanstack/react-query';
import { paymentApis } from '../api/paymentApi';

export const useResidentPaymentQuery = () => {
  return useQuery({
    queryKey: ['residentPaymentDetails'],
    queryFn: () => paymentApis.getAutoBillingStatus(),
  });
};
